<template>
    <v-container style="padding-top: 80px">
        <v-row mb-2>
            <v-chip class="ma-2 chipSize" :color="this.colorReporte" style="align-self: center" large
                @click="detalleReporte()">
                <span class="txtRep"> Reporte: {{ this.RepInd }} </span>
            </v-chip>

            <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
                <span class="txtEtiq">
                    {{ this.etiqueta }}
                </span>
            </v-chip>
        </v-row>
        <Decalogo v-if="valdecalogo" @Precierre="MostrarPrecierre"></Decalogo>
        <v-card class="mt-2 pb-0 mb-5" v-else>
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;"> Precierre </p>
            </v-card-title>

            <v-card-text style="margin-bottom: 4%;">
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <div class="mt-3">
                            <v-form ref="form" v-model="validForm" lazy-validation>
                                <v-row>
                                    <v-col cols="12">
                                        <div v-for="(item, index) in opcPrecierre" :key="index">
                                            <v-list-item>
                                                <v-list-item-action class="mr-1">
                                                    <v-checkbox :value="item.id" v-model="arrayPrecierre"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content class="document-chekboxes-style">
                                                    {{ item.descripcion }}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                        <span v-if="valopcPrec" class="error-message-style mb-3">Debe seleccionar al
                                            menos una opción</span>
                                    </v-col>
                                </v-row>
                                <v-row v-if="showfirma">
                                    <v-col cols="12">
                                        <div class="mt-2">
                                            <p>Para realizar la conclusión administrativa es necesario ingresar su firma
                                                electrónica</p>
                                            <span style="font-weight: bold;">Firma Electrónica Avanzada:</span>
                                            <v-text-field solo v-on:blur="firma = firma != null ? firma.trim() : null"
                                                dense hide-details style="-webkit-text-security: disc;" maxlength="17"
                                                v-model="firma" @keydown.enter.prevent>
                                            </v-text-field>
                                            <div v-if="errorFirma">
                                                <span class='spanError' style="color:red;font-size:12px">{{ messageFirma
                                                    }}</span>
                                                <br />
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <div class="mt-2">
                                            <v-icon id="publico" class="disable-action" :color="'#4CAF50'"
                                                large>mdi-lock-open</v-icon>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="mt-2">
                                            <span style="font-weight: bold;">Observaciones</span>
                                            <v-textarea
                                                v-on:blur="observaciones = observaciones != null ? observaciones.trim() : null"
                                                class="mt-2 textarea observaciones-pubCon" outlined hide-details
                                                v-model="observaciones" :rules="rulestextarea"></v-textarea>
                                            <span style="color: red;">{{ obsError }}</span>
                                        </div>
                                    </v-col>
                                </v-row>
                                <br />

                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disBtn"
                        @click="Guardar()">Guardar</v-btn>
                    <v-btn class="ma-2" color="default" title="Limpiar" @click="limpiar()" :disabled="disBtn">
                        Limpiar
                    </v-btn>
                    <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Lideres from "@/services/Lideres/Lideres.service.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import Decalogo from "@/components/pages/Lideres/components/Decalogo.vue"
import { mapState } from "vuex";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Decalogo
    },
    data() {
        return {
            valdecalogo: null,
            observaciones: "",
            opcPrecierre: [],
            rulestextarea: [
                (v) => !!v || "Campo requerido",
                (v) => {
                    if (v == null) {
                        return true;
                    } else {
                        if (v.trim().length < 12) {
                            return "Mínimo 12 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else return true;
                    }
                },
            ],
            obsError: "",
            messageFirma: "",
            firma: '',
            errorFirma: false,
            showfirma: false,
            arrayPrecierre: [],
            permisoCancelacionLider: false,
            valopcPrec: false,
            disBtn: false,
            validForm: true,
            reporte: {
                nrreporte: 0,
                svindice: 0
            },
            permisoLideres: false,
            colorReporte: '',
            RepInd: '',
            colorClass: "",
            etiqueta: '',
            sending: false,
        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    watch: {
        etiqueta(val) {
            if (val == "Abierto") {
                this.colorClass = "marginChip";
            } else if (val == "Concluido") {
                this.colorClass = "marginChipRed";
            } else if (val == "Cancelado") {
                this.colorClass = "marginChipPurple";
            } else if (val == "Conclusión Administrativa") {
                this.colorClass = "marginChipYellow";
            }
        },
        'arrayPrecierre'(val) {
            if (val.includes("chbCA")) {
                this.validarConclusionAdmin();
            } else {
                this.showfirma = false;
            }
            this.valopcPrec = false
        },
        'observaciones'(val) {
            if (val != '') {
                this.obsError = "";
            }
        },
        'valdecalogo'(val) {
            if (val == false) {
                this.datosPrecierre();
            }
        },
        async 'firma'(val) {
            if (val == null || val == '') {
                this.errorFirma = true;
                this.messageFirma = 'Campo requerido';
            }
            else {
                if (val.length < 8 || val.length > 16) {
                    this.errorFirma = true;
                    this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                }
                else {
                    this.errorFirma = false;
                }
            }
        },

    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40,149').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver lideres
                        this.permisoLideres = true;
                    if (permiso.peclave == 149)//Permiso para ver lideres
                        this.permisoCancelacionLider = true;
                });
            }
            if (this.permisoLideres == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        let reporte = await MetodosGenerales.obtenerSessionReporte('valider');
        this.reporte.nrreporte = reporte.nrreporte;
        this.reporte.svindice = reporte.svindice;
        this.reporte.aiclave = reporte.aiclave;
        this.reporte.svfhconclusion = reporte.svfhconclusion;

        this.valdecalogo = this.reporte.aiclave == 1 ? true : false;

        await Lideres.OpcionesPrecierre(this, this.reporte);

        let encabezado = await Lideres.EncabezadoReporte(this.reporte);
        this.RepInd = encabezado.nrreportei;
        this.colorReporte = encabezado.color;
        this.etiqueta = encabezado.etiqueta;
    },
    methods: {
        async detalleReporte() {
            let reporte = {
                nrreporte: this.reporte.nrreporte,
                svindice: this.reporte.svindice,
                aiclave: this.reporte.aiclave,
                svfhconclusion: this.reporte.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", this.reporte.nrreporte);
            formData.append("svindice", this.reporte.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });
            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });

            }
        },
        limpiar() {
            this.arrayPrecierre = [];
            this.observaciones = '';
            this.obsError = '';
            this.messageFirma = '';
            this.errorFirma = false;
        },
        Cancelar() {
            this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
        },
        async Validacion() {
            this.valopcPrec = this.arrayPrecierre.length == 0 ? true : false;
            if (this.observaciones == null || this.observaciones == '') {
                this.obsError = "Campo requerido";
            }
            if (this.observaciones != '') {
                if (this.observaciones.trim().length < 12) {
                    this.obsError = "Mínimo 12 Carácteres";
                }
                else if (this.observaciones.trim().length > this.$store.state.maxLengthComentarios) {
                    this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                }
                this.observaciones = this.observaciones.toUpperCase();
            }
            if (this.showfirma && this.firma == '') {
                this.messageFirma = 'Campo requerido';
                this.errorFirma = true;
            }
            if (this.permisoCancelacionLider == false) {
                this.errorFirma = true;
                this.messageFirma = 'No cuenta con la autorización para realizar esta acción';
            } else {
                if (this.showfirma && this.errorFirma == false) {
                    await this.ValidarFirma();
                }
            }

        },
        async datosPrecierre() {
            let response = await Lideres.ObtenerDatosPreCierre(this.reporte);
            if (response.DelitoGrave == true) { this.arrayPrecierre.push('chbDA') }
            if (response.Dictamen == true) { this.arrayPrecierre.push('chbDictamen') }
            if (response.Pago == true) { this.arrayPrecierre.push('chbPago') }
            if (response.Querella == true) { this.arrayPrecierre.push('chbQuerella') }
            if (response.RecuperacionDanos == true) { this.arrayPrecierre.push('chbRD') }
            if (response.Robo == true) { this.arrayPrecierre.push('chbRR') }
            // if (response.VehiculoDetenido == true) { this.arrayPrecierre.push('chbRR') }
        },
        async Guardar() {
            await this.Validacion();
            if (this.sending) { // Verifica si ya se está enviando
                return; // Si es así, no hace nada
            }
            this.sending = true; // Establece la variable de control en true
            this.disBtn = true; // Desactiva el botón de guardar
            if (!this.valopcPrec && this.obsError == '') {
                let response = await Lideres.ValidacionPrecierre(this.reporte, this.arrayPrecierre.join());
                if (response.Mensaje != '') {
                    this.$swal({
                        position: "center",
                        icon: "info",
                        title: "Información",
                        html: `${response.Mensaje}`,
                        confirmButtonText: "Aceptar",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowHtmlTags: true,
                    }).then(() => {
                    });
                }
                else if (response.aiclave == 1 && response.terceros == 0) {
                    this.$swal({
                        position: "center",
                        icon: "info",
                        title: "Información",
                        text: "No se ha registrado ningún Tercero ¿Desea guardar de todos modos?",
                        showCancelButton: true,
                        confirmButtonColor: '#536DFE',
                        cancelButtonColor: '#FF5C93',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            await this.GuardarPrecierre();
                        }
                    });
                } else {
                    await this.GuardarPrecierre();
                }
            }
            this.sending = false;
            this.disBtn = false;
        },
        MostrarPrecierre() {
            this.valdecalogo = false;
        },
        async validarConclusionAdmin() {
            let val = await Lideres.ValConclusionAdm(this.reporte);
            if (val != null) {
                const index = this.arrayPrecierre.indexOf('chbCA');
                if (index !== -1) {
                    this.arrayPrecierre.splice(index, 1);
                }
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    html: `${val}`,
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(async (result) => {
                    if (result.isConfirmed) {

                    }
                });
            } else {
                this.showfirma = true;
            }
        },
        async ValidarFirma() {
            let val = await Lideres.valFirmaElectronica(this.reporte, this.firma, 'Conclusión Administrativa');
            if (val == 0) {
                this.messageFirma = 'Firma electrónica incorrecta';
                this.errorFirma = true;
            }
        },
        async GuardarPrecierre() {
            if (this.showfirma == false) {
                let conclusion = await Lideres.ObtenerPosibleConclusion(this.reporte);
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    html: `Tú posible conclusión es: <b> ${conclusion.pcnombre} </b>. <br>¿Estás seguro de que es correcta? `,
                    showCancelButton: true,
                    confirmButtonColor: '#536DFE',
                    cancelButtonColor: '#FF5C93',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await this.GuardarMovimiento()
                    }
                });
            } else if (this.showfirma && !this.errorFirma) {
                await this.GuardarMovimiento()
            }
        },
        async GuardarMovimiento() {
            this.$swal({
                title: 'Guardando movimiento de pre cierre.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    let res = await MetodosGenerales.obtenerFechaHoraBase();
                    let today = res.today;
                    let response = await Lideres.GuardarPrecierre(this.reporte, 637, this.arrayPrecierre.join(), this.observaciones, this.showfirma, this.firma, today.toString(), 7);
                    if (response.validacion == true) {
                        let mensaje = '';
                        if (response.valor == 2) {
                            mensaje = "No se envió el comentario de conclusión, tiene que enviarlo de manera manual.";
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                html: "Pre cierre guardado exitosamente.<br/>" + mensaje,
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    this.$router.replace({ name: `LideresMain` }).catch(error => error);
                                }
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                html: "Pre cierre guardado exitosamente.<br/>",
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 4000
                            }).then(async () => {
                                this.$router.replace({ name: `LideresMain` }).catch(error => error);
                            });
                        }
                    } else if (response.validacion == false) {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Ocurrió un error, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 3000
                        })
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.error-message-style {
    font-family: "Roboto", sans-serif;
    color: #FF5C93;
    font-weight: 400;
    font-size: 12px;
}
</style>